// import url from '../../../utils/url.js'
import {cadastr} from '../../../api/api-endpoints.js'
import {ACTIONS, WALL} from '../../../config/config.js'
import {map as mapOfflineEndpoints} from '../../../api/api-offline-endpoints.js'
import FormValidator from '../../../components/form/form-validator.js'
import userFriendlyEr from '../../../utils/userFriendlyEr.js'
import yearHelper from '../../../utils/year.js'
import {OBJECT} from '../../../utils/map/types.js'
import permissionMixin from '../../../mixins/permission-mixin.js'
import {OBJECT_TO_OBJECT_AVAILABLE} from "../../../config/config"
import deepCopy from '../../../utils/deepCopy'

export default {
  mixins: [permissionMixin],
  data () {
    return {
      loading: false,
      saving: false,
      isObjectToObject: false,
      isGarbageSourceToObject: false,
      isSettlementToObject: false,
      id: null,
      startPoints: [
        'settlement',
        'garbageSource',
        'object'
      ],
      currentStartPointState: 0,
      currentStartPoint: 'settlement'
    }
  },
  created () {
    this.formValidator = new FormValidator()
  },
  computed: {
    // @bug
    updateScrollStreamName () {
      return 'geo.map-relation-update.scroll'
    },
    settlementsById () {
      let tmp = {}
      for (let key in this.settlements) {
        tmp[this.settlements[key].id] = this.settlements[key]
      }
      return tmp
    },
    settlements () {
      return this.$sharedServices.store.getters.readUrlEndpoint(this.getSettlementEndpoint(this.$sharedServices.router.history.current, {}))
    },
    garbageSources () {
      return this.$sharedServices.store.getters.readUrlEndpoint(this.getGarbageSourceEndpoint(this.$sharedServices.router.history.current, {}))
    },
    threadsTkoObjectsWithRealId () {
      let tmp = []
      let mapTkoObjectsById = this.mapTkoObjectsById
      for (let key in mapTkoObjectsById) {
        let tko = mapTkoObjectsById[key]
        tko.name = tko.id + ' ' + tko.name + ' ' + tko.address
        // !!! that code can destroy real id in store
        // use Object.assign({}, tko, opttions)
        tmp.push(Object.assign({}, tko))
      }
      return tmp
    },
    mapTkoObjectsById () {
      let tmp = {}
      let mapTkoObjects = this.mapTkoObjects
      delete mapTkoObjects.intermunicipal
      delete mapTkoObjects.mps
      for (let key in mapTkoObjects) {
        mapTkoObjects[key].forEach(v => {
          tmp[v.id] = Object.assign(tmp[v.id] || {}, v)
          tmp[v.id].type = OBJECT.TKO
          // TODO: default zoom
          tmp[v.id].showAfterZoom = 8
        })
      }
      return tmp
    },
    // TODO: return as array
    mapTkoObjects () {
      return this.$sharedServices.store.getters.readUrlEndpoint(this.getMapTkoObjectsEndpoint(this.$route))
    },
    // TODO: remove unsuse methods
    threadsTkoObjects () {
      return this.$sharedServices.store.getters
        .readUrlEndpoint(this.getThreadEndpoint(this.$sharedServices.router.history.current, {}))
        .threadsTkoObjects || []
    },
    threadsSettlementsById () {
      let tmp = {}
      for (let key in this.threadsSettlements) {
        tmp[this.threadsSettlements[key].id] = this.threadsSettlements[key]
      }
      return tmp
    },
    threadsSettlements () {
      return this.$sharedServices.store.getters
        .readUrlEndpoint(this.getThreadEndpoint(this.$sharedServices.router.history.current, {}))
        .threadsSettlements
    },
    enableOnAdd () {
      return ['fkkoName', 'code', 'total', 'count']
    },
    attributes () {
      return {
        fkkoName: {
          width: 200,
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions
          }
        },
        code: {
          width: 120,
          label: 'Код ФККО',
          required: false,
          placeholder: ' ',
          disabled: true,
          validationRulePattern: '^((\\d*\\s*)*)$'
        },
        danger: {
          width: 100,
          label: 'Класс опасности',
          required: false,
          disabled: true,
          placeholder: 'цифра',
          validationRulePattern: '^(\\d*)$'
        },
        value: {
          width: 100,
          label: 'Количество отходов, тонн',
          placeholder: '0.0000',
          validationRulePattern: '^(\\d*((\\.\\d{0,3}))?(\\d))$'
        },
        value_cub: {
          width: 100,
          label: 'Количество отходов, куб.м',
          placeholder: '0.0000',
          validationRulePattern: '^(\\d*((\\.\\d{0,3}))?(\\d))$'
        },
        tko_action_id: {
          width: 200,
          label: 'Вид деятельности',
          validationRulePattern: '(\\.*)',
          select: {
            options: this.optionsAction
          },
          transform: function (model) {
            if (model.tko_action_id) {
              for (let key in ACTIONS) {
                if (ACTIONS[key].tko_action_id === model.tko_action_id) {
                  return ACTIONS[key].label
                }
              }
            }
            return ''
          }
        }
      }
    },
    optionsAction () {
      let tmp = []
      for (let name in ACTIONS) {
        let v = ACTIONS[name]
        tmp.push({
          id: v.tko_action_id,
          name: v.label
        })
      }

      return tmp
    },
    dataUrl () {
      // if new record, offline save
      return mapOfflineEndpoints.threadsGarbage()
    },
    garbages () {
      return this.$sharedServices.store.getters.readUrlEndpoint(this.dataUrl).data
    },
    item () {
      return this.$sharedServices.store.getters.readUrlEndpoint(this.getItemEndpoint(this.id))
    }
  },
  methods: {
    // @bug: scroll attach to top/left if table empty
    tableEditableAfterFetchData () {
      console.log('tableEditableAfterFetchData')
      this.$emitter.emit(this.updateScrollStreamName, {
        action: 'reCreate'
      })
    },
    onSuccess ($event) {
      this.$swal({
        position: 'center',
        type: 'success',
        title: 'Запись сохранена',
        showConfirmButton: false,
        timer: WALL.SUCCESS_TIMEOUT
      })

      this.close($event)
    },
    saveForm ($event) {
      if (this.saving) {
        return
      }

      let sendForm = Object.assign({}, this.fields)
      sendForm.garbage = this.garbages
      let year = this.$sharedServices.router.history.current.query.year || yearHelper.getCurrentYear()

      let {hasError} = this.formValidator.validate(this)
      if (!hasError) {
        let storeActionName = (this.fields.id ? 'updateModel' : 'createModel')

        // create deep copy
        const data = deepCopy(sendForm)

        // if object to object, unset locality
        data.isObjectToObject = this.currentStartPoint === 'object'
        data.isGarbageSourceToObject = this.currentStartPoint === 'garbageSource'

        if (data.isObjectToObject) {
          data.localityIdName = ''
          data.locality_id = ''
        } else {
          data.startTkoObjectIdName = ''
          data.start_tko_object_id = ''
        }

        if (data.isGarbageSourceToObject) {
          data.startTkoObjectIdName = ''
          data.start_tko_object_id = ''
          data.localityIdName = ''
          data.locality_id = ''
        } else {
          data.garbageSourceIdName = ''
          data.garbage_source_id = ''
        }

        this.saving = true
        this.$sharedServices.store.dispatch(storeActionName, {
          url: this.getUpdateOrCreateUrl(this.fields.id, year),
          endpoint: this.getItemEndpoint(this.$route),
          data
        }).then(r => {
          this.saving = false

          // update map
          this.$emitter.emit('geo.mapUpdate', {
            component: 'map-relation-update',
            action: 'update',
            response: r
          })
          this.onSuccess($event)
        }).catch(erResponse => {
          this.saving = false

          console.error(erResponse)

          if (erResponse && +erResponse.status === 422) {
            let {notFoundedErrorFieldsText} = this.formValidator.handleServerErrors(erResponse, this)
            if (notFoundedErrorFieldsText) {
              this.$swal({
                position: 'center',
                type: 'error',
                title: 'Некорректно заполнены поля',
                text: notFoundedErrorFieldsText,
                showConfirmButton: false,
                timer: WALL.ERROR_TIMEOUT
              })
            }
          } else {
            this.$swal({
              position: 'center',
              type: 'error',
              title: userFriendlyEr.recognize(erResponse),
              showConfirmButton: false,
              timer: WALL.ERROR_TIMEOUT
            })
          }
        })
      }
    },
    swap () {
      this.currentStartPointState = this.startPoints.indexOf(this.currentStartPoint)
      this.currentStartPointState = this.currentStartPointState < this.startPoints.length - 1 ? this.currentStartPointState + 1 : 0
      this.currentStartPoint = this.startPoints[this.currentStartPointState]

      if (!OBJECT_TO_OBJECT_AVAILABLE && this.currentStartPoint === 'object' ) {
        console.warn('В данном регионе нельзя передавать отходы от объекта к объекту')
        return
      }
    },
    onSelect (ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.code = copy.code
        model.fkko_id = copy.id
        model.fkkoName = copy.fkkoName
        model.fkko = copy
        model.danger = copy.danger
      } else {
        model.code = ''
        model.fkko_id = ''
        model.fkkoName = ''
        model.fkko = {name: '', danger: '', code: ''}
        model.danger = ''
      }
    },
    suggestionEndpoint (ctx, q) {
      return cadastr.fkko({query: {q: q, 'per-page': 50}})
    },
    transformSuggestions (ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].code + ' ' + data[i].name,
          fkkoName: data[i].name,
          id: data[i].id,
          code: data[i].code,
          danger: data[i].danger
        })
      }
      return options
    },
    getActionLabelById (model) {
      for (let key in ACTIONS) {
        if (ACTIONS[key].tko_action_id === model.tko_action_id) {
          return ACTIONS[key].label
        }
      }
    },
    afterFetchData (ctx, data) {
      for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].tko_action_id) {
          data.data[i].actionsName = this.getActionLabelById(data.data[i].tko_action_id)
        } else {
          data.data[i].tko_action_id = ''
          data.data[i].actionsName = ''
        }

        if (data.data[i].fkko) {
          data.data[i].fkkoName = data.data[i].fkkoName || data.data[i].fkko.name
          data.data[i].code = data.data[i].fkko.code
          data.data[i].danger = data.data[i].fkko.danger
        } else {
          data.data[i].fkkoName = ''
        }
      }

      console.log('afterFetchData')
      return data
    },
    postUrl () {
      return null
    },
    patchUrl () {
      return null
    },
    deleteUrl () {
      return null
    },
    addNewRow () {
      const Model = () => {
        return {
          fkkoName: '',
          code: '',
          danger: '',
          tko_action_id: '',
          value: '',
          value_cub: ''
        }
      }
      // TODO: new row focus bag
      this.$refs.editTable.createRow(new Model())
    },
    clearGarbageTable () {
      // put garbage to store
      this.$sharedServices.store.commit('setEndpointData', {
        endpoint: this.dataUrl,
        data: {
          data: []
        }
      })
      // and update table
      this.$refs.editTable.fetchData()
    },
    resetFields (defaultData) {
      // put garbage to store
      this.$sharedServices.store.commit('setEndpointData', {
        endpoint: this.dataUrl,
        data: {
          data: []
        }
      })
      // and update table
      if (this.$refs.editTable) {
        this.$refs.editTable.fetchData()
      }

      this.fields = Object.assign({}, defaultData)
    },
    update () {
      // put garbage to store
      this.$sharedServices.store.commit('setEndpointData', {
        endpoint: this.dataUrl,
        data: {
          data: (this.item.garbage || [])
        }
      })
      // and update table
      this.$refs.editTable.fetchData()
      this.initFieldsAfterLoad()
      
      if (this.fields.start_tko_object_id) {
        this.currentStartPoint = 'object'
      } else if(this.fields.garbage_source_id) {
        this.currentStartPoint = 'garbageSource'
      } else {
        this.currentStartPoint = 'settlement'
      }
    },
    initFieldsAfterLoad() {
      this.fields = Object.assign({}, this.item)
    },
    fetchData () {
      this.loading = true
      this.$bar.start()
      this.$sharedServices.store.dispatch('updateUrlEndpoint', {
        endpoint: this.getItemEndpoint(this.id)
      }).then(() => {
        this.update()
        this.$bar.finish()
        this.loading = false
      }).catch(() => {
        this.$bar.finish()
        this.loading = false
      })
    }
  }
}
